export default "__VITE_ASSET__CEYjJ5zg__"